jQuery(document).ready((function($) {
    $('a[href*="#"]')
        .not('[href="#"]').not('[href="#0"]').click((function(event) {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();

                    var offset = 0;

                    if($(window).width()>=1024){
                      offset = $("#top-menu__wrap").outerHeight();
                    }


                    $('html, body').animate({
                        scrollTop: target.offset().top - offset
                    }, 1000, (function() {
                    }));
                }
            }
        }));
}));